export const WHEN_CALLED_SELECTION = 'when-called';
